export default "__VITE_ASSET__0d9bce62__"